module.exports = __webpack_public_path__ + "static/img/gaozhongshengwu.615fb26a.jpg";